import { classNames } from "primereact/utils";

import { useFormFieldContext } from "../form-field.context";
import styles from "../form-field.module.scss";
import { REQUIRED_MARK } from "../messages";
import type { FormFieldLabelProps } from "../types-form-field";

export function FormFieldLabel({
  children,
  visuallyHidden,
  className,
  ...rest
}: FormFieldLabelProps) {
  const { id, labelId, required, partTestId, classNames: parts } = useFormFieldContext();

  return (
    <label
      className={classNames(styles.label, parts.label, className)}
      data-visually-hidden={visuallyHidden ? "" : undefined}
      data-testid={partTestId("label")}
      {...rest}
      id={labelId}
      htmlFor={id}
    >
      {children}
      {required ? (
        <span className={styles.required} aria-hidden="true">
          {REQUIRED_MARK}
        </span>
      ) : null}
    </label>
  );
}
FormFieldLabel.displayName = "FormField.Label";
